import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LogOutComponent } from './log-out/log-out.component';
import { LoginComponent } from './login/login.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { LoginSelectionComponent } from './login-selection/login-selection.component';

const routes: Routes = [
  {path: 'login-selection', component: LoginSelectionComponent },
  {path: 'login', component: LoginComponent },
  {path: 'signup', component: SignUpComponent },
  {path: 'forgot-password', component: ForgotPasswordComponent },
  {path: 'new-password', component: NewPasswordComponent },
  {path: 'logout', component: LogOutComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountsRoutingModule { }
